import React from "react";
import type { ProjectAggregation, ProjectAggregationOptions } from "./useProjectAggregation";
import { useProjectAggegation } from "./useProjectAggregation";
import ReportingChartMenu from "../../ReportingChartMenu";
import t from "../../../../../i18n";
import { useTranslations } from "../../../../../api/useTranslations";

function ProjectAggregationSelector() {
  const translations = useTranslations();
  const [selectedProjectAggregation, setProjectAggregation] = useProjectAggegation({});

  const projectAggregationOptions: ProjectAggregationOptions = React.useMemo(
    () => [
      {
        label: t("reporting.chart.failure_aggregation.type", translations),
        value: "TYPE",
      },
      {
        label: t("reporting.chart.failure_aggregation.site"),
        value: "SITE",
      },
      {
        label: t("reporting.chart.failure_aggregation.project"),
        value: "PROJECT",
      },
    ],
    [translations],
  );

  return (
    <ReportingChartMenu<ProjectAggregation>
      options={projectAggregationOptions}
      currentValue={selectedProjectAggregation}
      setCurrentValue={setProjectAggregation}
    />
  );
}

export default React.memo(ProjectAggregationSelector);
